import { render, staticRenderFns } from "./ZDMEditor.vue?vue&type=template&id=9d10f702&"
import script from "./ZDMEditor.vue?vue&type=script&lang=js&"
export * from "./ZDMEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports